import { useLogin } from '@/hooks';
import { LoginPage } from '@workspace/auth';

export default function DealsLoginPage() {
    return <LoginPage appName="Deals" useLoginHook={useLogin} />;
}
